__webpack_require__.p = "/projekte/olympicwomen/";